import type { ReactNode } from 'react';
import { memo } from 'react';

import cn from 'classnames';

import cls from './input-text-fake.module.css';

interface InputTextFakeProps {
    value: string;
    className?: string;
    size?: 'small' | 'medium' | 'large';
    pictogram?: ReactNode;
}

export const InputTextFake = memo((props: InputTextFakeProps) => {
    const { value, className, size, pictogram } = props;

    return (
        <div
            className={cn(className, cls.root, {
                [cls.small]: size === 'small',
                [cls.medium]: size === 'medium',
                [cls.large]: size === 'large',
            })}
        >
            {pictogram && <span className={cls.pictogram}>{pictogram}</span>}
            <span>{value}</span>
        </div>
    );
});

InputTextFake.displayName = 'InputTextFake';
